import { testimonials as testimonialsZhTW } from './testimonials.zh-TW';
import { testimonials as testimonialsEn } from './testimonials.en';

export interface Testimonial {
  name: string;
  content: string;
  rating: number;
}

// Export function to get testimonials by language - use this with useTranslation hook
export const getTestimonialsByLanguage = (language: string): Testimonial[] => {
  switch (language) {
    case 'en':
      return testimonialsEn;
    case 'zh-TW':
      return testimonialsZhTW;
    default:
      return testimonialsEn;
  }
};
